import React from 'react';
import EImg from './EImg';
import EmojiVideo from './emoji-video.png';

export default ({ width = 24, height = 24 }) => (
	<EImg width={width} height={height} title="Television" aria-label="Emoji: Television" alt="📺" src={EmojiVideo} />
);
